import { formatArray } from "./format/array";
import { formatBoolean } from "./format/boolean";
import { formatDate } from "./format/date";
import type { FormatOptions } from "./format/format.types";
import { formatNumber } from "./format/number";
import { formatObject } from "./format/object";
import { formatString } from "./format/text";
import { isEmpty } from "./is-type";

export const format = (options: FormatOptions): string => {
  if (typeof options.value === "number" && Number.isNaN(options.value))
    return "-";
  if (isEmpty(options.value)) {
    if (options.value === "") return "-";
    return "NULL";
  }

  switch (options.format.kind) {
    case "BOOLEAN":
      return formatBoolean(Boolean(options.value));
    case "NUMBER":
    case "NUMBER_PLAIN":
    case "PERCENT":
    case "CURRENCY":
      return formatNumber(options);
    case "DATE":
      return formatDate(options);
    case "ARRAY":
      return formatArray(options);
    case "OBJECT":
      return formatObject(options);
    case "TEXT":
    case "EMAIL":
    case "URL":
    case "IMAGE":
    case "ENUM":
      return formatString(options);
  }

  // Fallback to string format
  return formatString(options);
};
